import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios'
import './customStyles.css'
import cross from '../images/ImageUpload/cross.png'
import upload from '../images/ImageUpload/upload.png'
import imageCompression from 'browser-image-compression';

function ImageUpload() {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;


    const [modifiedColors, setModifiedColors] = useState([])

    useEffect(() => {
        const fetchModfiedColors = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const data = await response.json();
                // console.log(data,'data');

                const modifiedColors = data.reduce((acc, item) => {
                    acc[item.db_color] = {
                        name: item.md_color?.toUpperCase() || '',
                        hex: item.hex || ''
                    };
                    return acc;
                }, {});

                setModifiedColors(modifiedColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };

        fetchModfiedColors()
    }, [])


    useEffect(() => {
        fetch(`${apiBaseUrl}/getCategories/BLACKBATON_2526`)
            .then(response => response.json())
            .then(data => setCategories(data));
    }, [apiBaseUrl]);

    useEffect(() => {
        if (selectedCategory) {

            fetch(`${apiBaseUrl}/getProductByCategory/BLACKBATON_2526?Id=${selectedCategory.value}`)
                .then(response => response.json())
                .then(data => setItems(data.map(item => ({
                    Id: item.ID,
                    ItemName: item.ItemName,
                    displayFirst: item.displayFirst,
                }))));
        }
    }, [selectedCategory, apiBaseUrl]);


    const handleCategoryChange = async (selectedCategory) => {
        setSelectedCategory(selectedCategory);

        setSelectedItem('');
        setSelectedImage(null);
        setEachItem([])
    };

    const [eachItem, setEachItem] = useState([])


    const [displayFirstCustom, setDisplayFirstCustom] = useState('')

    const [noSize, setNoSize] = useState(null)

    // console.log(noSize,'noSize');
    

    const fetchProduct = async (itemId) => {
            try {
                const response = await fetch(`${apiBaseUrl}/getProductById/BLACKBATON_2526?Id=${itemId}`);
                const data = await response.json();
                if (data.length > 0) {
                    setNoSize(data[0].noSize); // Extracting first object from array
                }
            } catch (error) {
                console.error('Error fetching product:', error);
            }
        };


    const handleGetItems = async (itemId) => {
        // console.log(itemId,'itemId');
        
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${itemId}`);
            // //(response,'ressss');

            if (response.status === 200) {
                // alert('d successfully.');

                // console.log(response.data,'response.data');

                fetchProduct(itemId)
                

                const loadingStatus = {};

                // Create a Set to track unique keys like "289_NAVY BLUE"
                const seen = new Set();

                response.data.forEach(({ ItemId, Color }) => {
                    const color = modifiedColors[Color?.toUpperCase()]?.name
                    const key = `${ItemId}_${color}`;
                    if (!seen.has(key)) {
                        seen.add(key);
                        loadingStatus[key] = true;  // Mark as loading
                    }
                });

                setLoadingPreviews(loadingStatus);



                setEachItem(response.data)
                fetchAllImageBlobs(seen)
                

                const selectedItem = items.find(item => item.Id === itemId);


                if (selectedItem) {
                    setDisplayFirstCustom(selectedItem.displayFirst)
                    setDisplayFirst(selectedItem.displayFirst);
                }

            } else {
                // alert('Image upload failed.');
            }
        } catch (error) {
            console.error('Error uploading image:', error);
            alert('Image uploaded successfully.');
        }
    }

    const handleItemChange = (selectedItem) => {
        if (selectedItem) {
            setSelectedItem(selectedItem.value);
            setSelectedImage(null);
            handleGetItems(selectedItem.value);
        } else {
            setSelectedItem('');
            setSelectedImage(null);
            // Optionally handle the "cleared" case here if needed
            setEachItem([])
        }
    };

    const [displayFirst, setDisplayFirst] = useState('')

    const [isUploading, setIsUploading] = useState(false)
    const [uploadStatus, setUploadStatus] = useState('idle');

    const [imageUploadingProgress, setImageUploadingProgress] = useState(0)


    const handleSaveImages = async () => {

        if (Object.keys(images).length === 0) {
            console.warn("No images to upload");
            if (displayFirstCustom === displayFirst) {
                return
            }
        }

        // const formData = new FormData();

        // // Append each image with its key (e.g., 1431, 1442) to formData
        // Object.entries(images).forEach(([key, file]) => {
        //     formData.append('images', file, `${key}.webp`);
        // });

        const payload = {
            slno: selectedItem,
            displayFirst: displayFirst
        }


        if (Object.keys(images).length > 0) {

            setIsUploading(true)
            setUploadStatus('saving');

            const formData = new FormData();

            const options = {
                maxSizeMB: 5,                   // 🔼 Increase this to allow better quality
                // maxWidthOrHeight: 3840,        // ✅ 4K resolution
                useWebWorker: true,
                fileType: 'image/webp',
                initialQuality: 1           // 🔼 Explicitly increase quality (range: 0.1 to 1.0)
            };            

            const totalImages = Object.keys(images).length + 1;
            let completed = 0;

            for (const [key, file] of Object.entries(images)) {
                try {
                    // Log original size
                    // const originalSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                    // console.log(`Original [${key}]: ${originalSizeMB} MB`);

                    const compressedFile = await imageCompression(file, options);

                    // Log compressed size
                    // const compressedSizeMB = (compressedFile.size / (1024 * 1024)).toFixed(2);
                    // console.log(`Compressed [${key}]: ${compressedSizeMB} MB`);

                    const renamedFile = new File([compressedFile], `${key}.webp`, {
                        type: 'image/webp',
                    });
                    formData.append('images', renamedFile);

                    // ✅ Update progress after each image compression
                    completed++;
                    const percent = Math.round((completed / totalImages) * 100);
                    setImageUploadingProgress(percent);

                } catch (err) {
                    console.error(`Compression error on [${key}]:`, err);
                }
            }

            try {
                const response = await fetch(`${apiLocalUrl}/upload-image1`, {
                    method: 'POST',
                    body: formData,
                });

                if (response.status === 200) {

                    setUploadStatus('success');

                    setImageUploadingProgress(100);

                    setTimeout(() => {
                        setImages({})
                        setPreviews({})
                        setSelectedCategory('')
                        setSelectedItem('')
                        setEachItem([])
                        setDisplayFirst('')
                        setDisplayFirstCustom('')
                        setIsUploading(false);
                        setUploadStatus('idle');
                    }, 1000);

                }

            } catch (error) {
                console.error('Error uploading images:', error);
            }
        }

        try {
            const response = await fetch(`${apiBaseUrl}/postDisplayFirst`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            if (response.status === 200 && Object.keys(images).length === 0) {
                alert('Display image updated.')
            }

        } catch (error) {
            console.error('Error updating display first:', error);
        }


    };


    const [images, setImages] = useState({});
    const [previews, setPreviews] = useState({});




    const [loadingPreviews, setLoadingPreviews] = useState({});

    //  console.log(previews,'previews');
    // console.log(loadingPreviews, 'loadingPreviews');

    const fileInputRef = useRef(null)

    const handleDivClick = (code) => {
        // If a preview already exists for this item, do nothing
        if (previews[code]) return;
        // Otherwise, open the file input for this item
        fileInputRef.current?.click();
    };


    const handleImageChange = (e, code) => {
        const file = e.target.files[0];
        if (file) {
            const newImages = { ...images, [code]: file };
            const newPreviews = { ...previews, [code]: URL.createObjectURL(file) };
            setImages(newImages);
            setPreviews(newPreviews);
        }
    };


    const [imageErrors, setImageErrors] = useState({});

    const handleImageError = (code) => {
        setImageErrors(prev => ({ ...prev, [code]: true }));
    };

    const fetchAllImageBlobs = async (seen) => {
        try {
            const response = await axios.get(`${apiLocalUrl}/getImages`);
            const images = response.data;
    
            const foundKeys = new Set();
    
            // Step 2: Process each image asynchronously and update state
            for (const { name, data } of images) {
                const imageKey = name.replace('.webp', '');
    
                const blob = new Blob(
                    [Uint8Array.from(atob(data), c => c.charCodeAt(0))],
                    { type: 'image/webp' }
                );
                const url = URL.createObjectURL(blob);
    
                // Save preview and mark as found
                setPreviews(prev => ({
                    ...prev,
                    [imageKey]: url
                }));
    
                setLoadingPreviews(prev => ({
                    ...prev,
                    [imageKey]: false
                }));
    
                foundKeys.add(imageKey);
            }
    
            // ✅ Now handle keys in `seen` that were not found in image blobs
            seen.forEach((key) => {
                if (!foundKeys.has(key)) {
                    setLoadingPreviews(prev => ({
                        ...prev,
                        [key]: false
                    }));
                }
            });
    
        } catch (err) {
            setLoadingPreviews({});
            console.error('Error fetching image blobs:', err);
        }
    };
    


    // useEffect(() => {
    //     eachItem
    //         .forEach((match) => {
    //             const code = match.Uniquecode;
    //             //(code,'code');
    //             if (!previews[code]) {
    //                 fetchImageAsBlob(code);
    //             }
    //         });
    // }, [eachItem,selectedImage]);


    return (
        <div className="relative max-w-3xl mx-auto p-6 bg-[#dcdcdc] shadow-lg rounded-lg mt-10">
            <h1 className="text-2xl font-bold text-center text-gray-700 mb-6">Image Upload</h1>

            <div className="mb-4">
                <label className="block text-gray-600 font-semibold mb-2">Select Category:</label>
                <Select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    options={categories.map(category => ({ value: category.Id, label: category.Name }))}
                    className="w-full"
                    classNamePrefix="select"
                    isClearable
                    isSearchable
                />
            </div>

            {selectedCategory && (
                <div className="mb-4">
                    <label className="block text-gray-600 font-semibold mb-2">Select Item:</label>
                    <Select
                        onChange={handleItemChange}
                        value={selectedItem.label}
                        options={items.map(item => ({ value: item.Id, label: item.ItemName }))}
                        className="w-full"
                        classNamePrefix="select"
                        isClearable
                        isSearchable
                    />
                </div>
            )}

            <div className='w-full flex flex-wrap'>
                {[...new Map(
                    eachItem
                        .map(innerItem => [innerItem.Color, innerItem]) // Map by Color
                ).values()]
                    .filter(item => modifiedColors[item.Color]?.name)
                    .reduce((acc, item) => {
                        const mappedColor = modifiedColors[item.Color]?.name;
                        if (!acc.seen.has(mappedColor)) {
                            acc.seen.add(mappedColor);
                            acc.result.push(item); // Keep only one item per unique mappedColor
                        }
                        return acc;
                    }, { seen: new Set(), result: [] })
                    .result
                    .map((match, index) => {
                        // let code;

                        const itemId = match.ItemId;
                        // const color = match.Color;
                        const color = modifiedColors[match.Color?.toUpperCase()]?.name

                        const code = [`${itemId}_${color}`]

                        const hasError = imageErrors[code];

                        // const modifiedColor = modifiedColors[match.Color?.toUpperCase()]
                        // const bgColor = colorMap[color];
                        const bgColor = modifiedColors[match.Color?.toUpperCase()]?.hex || '';

                        return (
                            <div key={index} className='w-32 py-1 mr-4 rounded flex flex-col gap-2'>
                                <div className='w-full flex gap-2 justify-start items-center'>
                                    <div className='w-full flex gap-2 justify-start items-center text-left'>
                                        <div
                                            className='w-4 h-4 rounded-full border'
                                            style={{ backgroundColor: bgColor || '#ccc' }}
                                        ></div>
                                        <span className='text-sm'>{modifiedColors[match.Color?.toUpperCase()]?.name}</span>
                                    </div>
                                    {previews[code] && (
                                        <div className='w-max h-full flex justify-center items-center'>
                                            <input name="productColour" className='cursor-pointer w-4 h-4' type="radio"
                                                checked={displayFirst === `${code}.webp`}
                                                onChange={() => {
                                                    setDisplayFirst(`${code}.webp`)
                                                }} />
                                        </div>
                                    )}
                                </div>
                                <div className='border border-dashed rounded-md border-[#000] w-32 h-32'>
                                    <div
                                        className={`w-32 h-32 flex justify-center items-center borderDashed rounded-[.313rem] ${(!previews[code] && !loadingPreviews[code]) ? 'cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (!previews[code] && !loadingPreviews[code]) {
                                                document.getElementById(`file-${code}`).click()
                                            }
                                        }}
                                    >
                                        <input
                                            type="file"
                                            id={`file-${code}`}
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleImageChange(e, code)}
                                            accept="image/*"
                                        />
                                        {(loadingPreviews[code]) ? (
                                            // Show spinner if loading
                                            <div className="w-full h-full flex justify-center items-center relative bg-white bg-opacity-40">
                                                <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                                            </div>
                                        ) : previews[code] ? (
                                            // Show image if loaded
                                            <div className='w-full h-full relative flex justify-center items-center p-[.1rem]'>
                                                <img
                                                    className='w-full h-full rounded-[.313rem]'
                                                    src={previews[code]}
                                                    alt="Uploaded"
                                                    onLoad={() =>
                                                        setLoadingPreviews((prev) => ({ ...prev, [code]: false }))
                                                    }
                                                    onError={() =>
                                                        setLoadingPreviews((prev) => ({ ...prev, [code]: false }))
                                                    }
                                                />

                                                {/* Remove Button */}
                                                <div
                                                    className='absolute top-[.1rem] right-[.1rem] p-1 rounded-bl-[.313rem] rounded-tr-[.313rem] bg-[#fff] cursor-pointer'
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const newImages = { ...images };
                                                        const newPreviews = { ...previews };
                                                        const newLoading = { ...loadingPreviews };
                                                        delete newImages[code];
                                                        delete newPreviews[code];
                                                        delete newLoading[code];
                                                        setImages(newImages);
                                                        setPreviews(newPreviews);
                                                        setLoadingPreviews(newLoading);
                                                    }}
                                                >
                                                    <img className='w-[1rem]' src={cross} alt="Remove" />
                                                </div>
                                            </div>
                                        ) : !previews[code] && (
                                            // Show upload placeholder if nothing
                                            <div className='flex flex-col justify-center items-center'>
                                                <img className='w-[2rem]' src={upload} alt="Upload" />
                                                <span className='text-center mt-2 text-sm'>Upload <br />Image</span>
                                            </div>
                                        )}


                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>


            {(Object.keys(images).length > 0 || (displayFirstCustom !== displayFirst)) && (
                <div className='w-full flex justify-start items-center mt-5'>
                    <button className='py-2 px-10 bg-[#c30000] text-white rounded-md' onClick={handleSaveImages}>Save</button>
                </div>
            )}

            {isUploading && (
                <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex flex-col gap-5 justify-center items-center">
                    {uploadStatus === 'saving' && (
                        <>
                            <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-white border-solid"></div>
                            {/* <p className="text-white text-2xl">Saving...</p> */}
                            <div className="w-1/2 bg-gray-200 rounded-full h-4 mt-4">
                                <div
                                    className="bg-blue-500 h-4 rounded-full transition-all duration-300 ease-in-out"
                                    style={{ width: `${imageUploadingProgress}%` }}
                                ></div>
                            </div>
                            <p className="text-lg font-semibold mt-1 text-white">{imageUploadingProgress}%</p>
                        </>
                    )}
                    {uploadStatus === 'success' && (
                        <>
                            <div className="rounded-full h-20 w-20 border-4 border-green-500 flex items-center justify-center">
                                <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <p className="text-green-400 text-2xl">Successful</p>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default ImageUpload;
